// Paket M6 — useMembership-Hook.
//
// Stellt die aktuelle Membership (Entitlements + aktive Subscription) als
// react-query-Daten bereit. Benoetigt einen authentifizierten Nutzer; gibt
// ausserhalb einen defensiven Default zurueck, damit Aufrufer in Gast-Sheets
// nicht selbst auf `enabled` achten muessen.
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import {
  getMembership,
  DEFAULT_NORMALIZED_TIER as _FALLBACK,
  type BadgeTier,
  type Entitlements,
  type MembershipSnapshot,
  type MembershipTier,
} from '../api/membership';
import { queryKeys } from '../api/queryKeys';

export interface UseMembershipResult {
  snapshot: MembershipSnapshot;
  isLoading: boolean;
  tier: MembershipTier;
  badge: BadgeTier | null;
  entitlements: Entitlements;
}

export function useMembership(): UseMembershipResult {
  const auth = useAuth();
  const isAuthed = auth.status === 'authed';
  const query = useQuery({
    queryKey: queryKeys.membership.snapshot(),
    queryFn: getMembership,
    enabled: isAuthed,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  const fallback: MembershipSnapshot = _FALLBACK;
  const data = query.data ?? fallback;
  return {
    snapshot: data,
    isLoading: query.isPending,
    tier: data.entitlements.tier,
    badge: data.entitlements.badge,
    entitlements: data.entitlements,
  };
}

export default useMembership;
